import {IAnyObject} from "../../common/SimpleInterface";
import {FactoryID} from "../../model-factory/type-interface/ModelFactoryType";
import PostDataFactory, {IPostDataChoices, PostDataChoice, PostDataModel} from "./PostDataFactory";
import ApiRequestVO from "../../manager/api/ApiRequestVO";
import ApiError from "../../manager/api/ApiError";

export class PageDataChoice extends PostDataChoice
{

    constructor(object:IAnyObject)
    {
        super(object);
        this.postID = object.post_id && !isNaN(object.post_id) ? parseInt(object.post_id) : 0;
    }

    getPageID():string|null
    {
        return this.id;
    }

    isDataAppliedExternally():boolean
    {
        return true;
    }

    getParentChoice():PostDataChoice|null {
        return  null;
    }
}

export interface IPageDataChoices extends IPostDataChoices
{
    [key: string]: PageDataChoice;
}

export class PageDataModel extends PostDataModel
{
    choices: IPageDataChoices = {};

    getPopulateRequestVO(requestedIDs?:string[]): ApiRequestVO|null
    {
        const requestVO = new ApiRequestVO();
        requestVO.endpoint = "/post/page/list";
        return requestVO;
    }

    populateWithRequestResponse(response: IAnyObject, replaceData:boolean): ApiError | null
    {
        const populateResponse = super.populateWithRequestResponse(response, replaceData);
        if(populateResponse){
            return populateResponse;
        }

        const choiceList = this.choiceList();
        for(const choice of choiceList){
            choice.applyAcfData();
            choice.applyContentBlocks();
        }
        return null;
    }


    applyModelConditions()
    {
        super.applyModelConditions();
        this.postType = "page";
    }

    choiceList(choiceOrder?: string[]): PageDataChoice[]
    {
        return super.choiceList(choiceOrder) as PageDataChoice[];
    }


    createChoice(object: IAnyObject): PageDataChoice | null
    {
        return super.createChoice(object) as PageDataChoice;
    }

    factory(): PageDataFactory
    {
        return super.factory() as PageDataFactory;
    }
}

export default class PageDataFactory extends PostDataFactory
{

    id: FactoryID = "page_data";


    birth(id: string): PageDataModel
    {
        return new PageDataModel(id)
    }

    birthDataChoice(object:IAnyObject): PageDataChoice
    {
        return new PageDataChoice(object);
    }

    getPageDataModel(): PageDataModel
    {
        return this.getPostDataModel("page") as PageDataModel
    }

    reset(){
        //doesn't get reset
    }
}